import(/* webpackMode: "eager" */ "/home/runner/work/joydrop-ui/joydrop-ui/src/app/global-error.tsx");
